import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  GECKO_CONSTS,
  GeckoToastService,
  GeckoCard,
  GeckoCardHeader,
  GeckoCardBody,
  GeckoCardFooter,
  GeckoField,
  GeckoBtnsSorted,
} from 'ui';
import RecurringImportDetails from './RecurringImportDetails';
import GeckoEvents from 'services/gecko-events';
import GeckoRequest from 'services/gecko-request';

class DynamicsRecurringImportCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      target: null,
    };
    this.handleImportUpdate = this.handleImportUpdate.bind(this);
  }

  static propTypes = {
    integration: PropTypes.object,
    targets: PropTypes.array,
    lastImport: PropTypes.object,
  };

  componentDidMount() {
    const { recurring_import } = this.props.integration.configuration;
    if (recurring_import) {
      this.setState({ target: recurring_import.target });
    }
    this.setState({ integration: this.props.integration });
    if (this.props.lastImport) {
      this.setState({ lastImport: this.props.lastImport });
    }
    GeckoEvents.subscribe('syncrecord:updated', this.handleImportUpdate);
  }

  componentWillUnmount() {
    GeckoEvents.unsubscribe('syncrecord:updated', this.handleImportUpdate);
  }

  handleImportUpdate(update) {
    if (this.state.lastImport && update.id === this.state.lastImport.id) {
      this.setState({ lastImport: update });
    }
  }

  saveRecurringImport() {
    GeckoRequest.post('/integration/dynamics/recurring-import', {
      target: this.state.target,
    })
      .then((integration) => {
        new GeckoToastService().success(
          this.state.integration.configuration.recurring_import
            ? 'User Query updated'
            : 'Recurring import created'
        );
        this.setState({ integration });
      })
      .catch((err) => {
        console.error(err);
        return new GeckoToastService().error(err);
      });
  }

  startImport() {
    const { recurring_import } = this.state.integration.configuration;
    if (
      !recurring_import ||
      !recurring_import.target ||
      this.state.target !== recurring_import.target
    ) {
      return new GeckoToastService().error(
        'You must save your User Query selection before triggering an Import'
      );
    }
    return GeckoRequest.post('/integration/dynamics/sync', {
      target: recurring_import.target,
    })
      .then(() => {
        new GeckoToastService().success('Import started');
        const handleNewSyncRecord = (syncRecord) => {
          if (
            syncRecord.third_party_id === String(recurring_import.target) &&
            syncRecord.sync_type === 'recurring contact import'
          ) {
            this.setState({ lastImport: syncRecord });
            GeckoEvents.unsubscribe('syncrecord:created', handleNewSyncRecord);
          }
        };
        GeckoEvents.subscribe('syncrecord:created', handleNewSyncRecord);
      })
      .catch((err) => {
        console.error(err);
        new GeckoToastService().error(err);
      });
  }

  importDisabled() {
    if (
      this.state.lastImport &&
      (this.state.lastImport.sync_status === 'in progress' ||
        this.state.lastImport.sync_status === 'new')
    ) {
      return true;
    }
    if (
      this.state.integration &&
      !this.state.integration.configuration.recurring_import
    ) {
      return true;
    }
    if (
      this.state &&
      this.state.target &&
      this.state.integration &&
      this.state.target !==
        this.state.integration.configuration.recurring_import.target
    ) {
      return true;
    }
    return false;
  }

  render() {
    return (
      <div className="DynamicsRecurringImportCard">
        <GeckoCard>
          <GeckoCardHeader name="Recurring Import Configuration" />
          <GeckoCardBody>
            <div className="content-margin">
              <GeckoField
                values={{ target: this.state.target }}
                field={{
                  key: 'target',
                  type: GECKO_CONSTS.FIELD_TYPE_SELECT,
                  options: this.props.targets,
                  label: 'Select Target:',
                  description:
                    'Choose a User Query from Dynamics to be imported into Gecko Chat on a recurring basis.',
                }}
                handler={(_key, value) => this.setState({ target: value })}
              />
              <RecurringImportDetails
                showProgress={false}
                syncRecord={this.state.lastImport}
              />
            </div>
          </GeckoCardBody>
          <GeckoCardFooter>
            <GeckoBtnsSorted
              items={[
                {
                  secondary: true,
                  name: 'Import Now',
                  type: GECKO_CONSTS.BTN_TYPE_DEFAULT,
                  icon: 'far fa-download',
                  handler: this.startImport.bind(this),
                  disabledWhen: this.importDisabled.bind(this),
                },
                {
                  primary: true,
                  name: 'Save',
                  type: GECKO_CONSTS.BTN_TYPE_PRIMARY,
                  icon: 'far fa-save',
                  handler: this.saveRecurringImport.bind(this),
                },
              ]}
            />
          </GeckoCardFooter>
        </GeckoCard>
      </div>
    );
  }
}

export default DynamicsRecurringImportCard;
